<template>
  <main class="el-kuang">
    <!-- <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <img
        draggable="false"
        src="../../static/20201225190618.jpg"
        style="width: 100%; height: 100%"
        alt
      />
    </el-dialog>-->
    <!-- Start Slider Area -->
    <div class="intro-area lunbotu">
      <div class="intro-carousel">
        <div class="intro-content">
          <div class="slider-images">
            <img draggable="false" src="../assets/new/img/slider/s1.jpg" alt />
          </div>
          <div class="slider-content">
            <div class="container">
              <div class="row">
                <div class="col-md-12 text-center">
                  <!-- layer 1 -->
                  <div class="layer-1-2">
                    <h1 class="title2">
                      海星云电脑，一个能将您身边的屏幕变成超级电脑的魔法
                    </h1>
                  </div>
                  <div class="layer-1-1 hidden-xs">
                    <p></p>
                  </div>
                  <!-- layer 3 -->
                  <div class="layer-1-3">
                    <router-link :to="{ path: '/DownLoad' }" class="ready-btn"
                      >下载客户端</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="intro-content">
          <div class="slider-images">
            <img draggable="false" src="../assets/new/img/slider/s2.jpg" alt />
          </div>
          <div class="slider-content">
            <div class="container">
              <div class="row">
                <div class="col-md-12 text-center">
                  <div class="layer-1-2">
                    <h1 class="title2 yingjie">专业客服为您解答问题</h1>
                  </div>

                  <div class="layer-1-3">
                    <div class="ready-btn" @click="linkdenglu">注册/登录</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="intro-content">
          <div class="slider-images">
            <img draggable="false" src="../assets/new/img/slider/s3.jpg" alt />
          </div>
          <div class="slider-content">
            <div class="container">
              <div class="row">
                <div class="col-md-12 text-center">
                  <div class="layer-1-2">
                    <h1 class="title2">
                      <!-- 400多款游戏 N多款3A游戏大作  -->
                      无需下载 即点即玩
                    </h1>
                  </div>
                  <div class="layer-1-1 hidden-xs">
                    <!-- <p>400多款游戏 N多款3A游戏大作</p> -->
                  </div>

                  <div class="layer-1-3">
                    <router-link :to="{ path: '/DownLoad' }" class="ready-btn"
                      >下载客户端</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="intro-content">
          <div class="slider-images">
            <img draggable="false" src="../assets/new/img/slider/s4.jpg" />
          </div>
          <div class="slider-content">
            <div class="container">
              <div class="row">
                <div class="col-md-12 text-center">
                  <div class="layer-1-2">
                    <h1 class="title2">
                      海星云数据中心扩容在即，诚招各地联营代理加盟！
                    </h1>
                  </div>
                  <div class="layer-1-1 hidden-xs">
                    <p>共享国家“新基建”投资发展红利！</p>
                  </div>
                  <div class="layer-1-3">
                    <div class="ready-btn" @click="detail">了解更多</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
    <!-- End Slider Area -->
    <!-- Welcome service area start -->
    <div class="services-area bg-color-2 area-padding">
      <div class="container">
        <div class="row">
          <div class="services-carousel">
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img
                    draggable="false"
                    src="../assets/new/img/feature/1.jpg"
                    alt
                  />
                  <div class="image-layer">
                    <img
                      draggable="false"
                      src="../assets/new/img/icon/g1.png"
                      alt="icon Image"
                    />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>巫师3：狂猎</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 9.6</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://store.steampowered.com/app/292030/The_Witcher_3_Wild_Hunt/"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img
                    draggable="false"
                    src="../assets/new/img/feature/2.jpg"
                    alt
                  />
                  <div class="image-layer">
                    <img
                      draggable="false"
                      src="../assets/new/img/icon/g2.png"
                      alt="icon Image"
                    />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>使命召唤:冷战</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 9.4</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://www.callofduty.com/cn/zh/"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img
                    draggable="false"
                    src="../assets/new/img/feature/4.jpg"
                    alt
                  />
                  <div class="image-layer">
                    <img
                      draggable="false"
                      src="../assets/new/img/icon/g1.png"
                      alt="icon Image"
                    />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>赛博朋克2077</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 9.8</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://store.steampowered.com/app/1091500/Cyberpunk_2077/"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img src="../assets/new/img/feature/6.jpg" alt />
                  <div class="image-layer">
                    <img src="../assets/new/img/icon/g1.png" alt="icon Image" />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>怪物猎人:世界</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 9.4</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://store.steampowered.com/app/582010/Monster_Hunter_World/"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img src="../assets/new/img/feature/7.jpg" alt />
                  <div class="image-layer">
                    <img src="../assets/new/img/icon/g1.png" alt="icon Image" />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>无主之地3</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 9.0</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://store.steampowered.com/app/397540/3/"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end new -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img
                    draggable="false"
                    src="../assets/new/img/feature/11.jpg"
                    alt
                  />
                  <div class="image-layer">
                    <img
                      draggable="false"
                      src="../assets/new/img/icon/uplay.png"
                      alt="icon Image"
                    />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>看门狗：军团</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">发行日期: 2020年10月29日</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://store.ubi.com/cn/%E7%9C%8B%E9%97%A8%E7%8B%97%EF%BC%9A%E5%86%9B%E5%9B%A2/5cec2d5839798c0870c07698.html?ncid=1979-4569---1-intdp-49-12-store_web_WDL_E3PR_CN_0610--27-29-7-0619-4-2---ID_77399-1-1-3--&maltcode=ubisoftstore_convst_intdp_cnofficalwebsite_vg_nr_ORW_se_Pre__"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img
                    draggable="false"
                    src="../assets/new/img/feature/8.jpg"
                    alt
                  />
                  <div class="image-layer">
                    <img
                      draggable="false"
                      src="../assets/new/img/icon/g1.png"
                      alt="icon Image"
                    />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>漫威复仇者联盟</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 8.0</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://store.steampowered.com/app/997070/Marvels_Avengers/"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img
                    draggable="false"
                    src="../assets/new/img/feature/5.jpg"
                    alt
                  />
                  <div class="image-layer">
                    <img
                      draggable="false"
                      src="../assets/new/img/icon/g3.png"
                      alt="icon Image"
                    />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>战地5</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 7.9</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://www.origin.com/hkg/en-us/store/battlefield/battlefield-v"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img
                    draggable="false"
                    src="../assets/new/img/feature/9.jpg"
                    alt
                  />
                  <div class="image-layer">
                    <img
                      draggable="false"
                      src="../assets/new/img/icon/g1.png"
                      alt="icon Image"
                    />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>骑马与砍杀2</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 8.8</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://store.steampowered.com/app/261550/Mount__Blade_II_Bannerlord/"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img
                    draggable="false"
                    src="../assets/new/img/feature/10.jpg"
                    alt
                  />
                  <div class="image-layer">
                    <img
                      draggable="false"
                      src="../assets/new/img/icon/g1.png"
                      alt="icon Image"
                    />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>死亡搁浅</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 8.5</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://store.steampowered.com/app/1190460/DEATH_STRANDING/"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-services text-center">
                <div class="services-img">
                  <img
                    draggable="false"
                    src="../assets/new/img/feature/3.jpg"
                    alt
                  />
                  <div class="image-layer">
                    <img
                      draggable="false"
                      src="../assets/new/img/icon/g1.png"
                      alt="icon Image"
                    />
                  </div>
                </div>
                <div class="main-services">
                  <div class="service-content">
                    <h4>绝地求生：大逃杀</h4>
                    <div class="pro-rating no-rating">
                      <span class="rating-rate">评分: 8.1</span>
                    </div>
                    <a
                      class="service-btn"
                      target="blank"
                      href="https://store.steampowered.com/app/578080/PLAYERUNKNOWNS_BATTLEGROUNDS/"
                      >了解一下</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- single-well end-->
          </div>
        </div>
      </div>
    </div>
    <!-- Welcome service area End -->
    <div class="About-feature-area bg-color-1 page-padding">
      <div class="container">
        <div class="row">
          <div class="about-feature">
            <!-- Start column -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-about">
                <div class="feature-icon">
                  <i class="icon icon-cloud"></i>
                </div>
                <div class="feature-text">
                  <h4>云计算</h4>
                  <p>
                    游戏渲染与计算放在云端，本地无需再堆叠配置，耗电量也相应大幅减少，游玩时长与游戏质量都得到了次世代级的提升。
                  </p>
                </div>
              </div>
            </div>
            <!-- Start column -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-about">
                <div class="feature-icon">
                  <i class="icon icon-layers"></i>
                </div>
                <div class="feature-text">
                  <h4>跨平台</h4>
                  <p>
                    一款游戏多平台畅玩。“小破本”？
                    MAC本？安卓手机？海星云平台通通帮您搞定！
                  </p>
                </div>
              </div>
            </div>
            <!-- Start column -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-about">
                <div class="feature-icon">
                  <i class="icon icon-clock"></i>
                </div>
                <div class="feature-text">
                  <h4>无需等待</h4>
                  <p>
                    云电脑时代，游戏的下载与更新配置在服务器端完成，你无需再等待，点开即享。
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                </div>
              </div>
            </div>
            <!-- End column -->
          </div>
        </div>
      </div>
    </div>
    <div class="product-area bg-color-1 area-padding">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="section-headline white-headline text-center">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="product-content text-center">
                  <div class="layer-1-3">
                    <a
                      href="https://www.speedtest.net/zh-Hans"
                      target="blank"
                      class="ready-btn"
                      >测速</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <p>海星云游戏平台支持从720P到4K画质的流畅游戏体验。您需要至少10Mbps的网速来支持高清的画质，25Mbps以上的建议网速来体验4K，60FPS的效果。</p> -->
        <div class="row">
          <div class="best-product">
            <!-- Start single product -->
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/new/img/product/p4.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- End single product -->
          </div>
        </div>
      </div>
    </div>
    <!-- Start Product Area -->
    <div class="product-area bg-color-1 area-padding">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-10 col-xs-12">
            <div class="section-headline white-headline text-center">
              <h3>多平台畅玩海星云电脑</h3>
              <p>下载客户端来访问您的超级电脑</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="best-product">
            <!-- Start single product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">Windows</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/images/xz/win.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span>适用于WINDOWS XP及以上</span>
                    </div>
                    <div class="text-center" style="display: flex; justify-content: center; margin-top: 10px">
                      <div style="">
                        <div class="layer-1-3">
                          <a
                            href='https://download.haixingcloud.com/static/download/haixingcloud-setup.exe'
                            class="ready-btn"
                          >Win 64位下载</a
                          >
                        </div>
                        <div class="version-update">
                          <div>版本&nbsp;{{ pcNewVer.version_number || "" }}</div>
                          <div>
                            更新日期&nbsp;:&nbsp;&nbsp;{{
                              pcNewVer.createdat | fmtDate
                            }}
                          </div>
                        </div>
                      </div>
                      <div style="margin-left: 20px">
                        <div class="layer-1-3">
                          <a
                            href='https://download.haixingcloud.com/static/download/haixingcloud-setup-x86.exe'
                            class="ready-btn"
                          >Win 32位下载</a
                          >
                        </div>
                        <div class="version-update">
                          <div>版本&nbsp;{{ pc32NewVer.version_number || "" }}</div>
                          <div>
                            更新日期&nbsp;:&nbsp;&nbsp;{{
                              pc32NewVer.createdat | fmtDate
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="version-box"></div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- End single product -->
            <!-- Start single product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">Mac</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/new/img/product/p2.jpg"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span>适用于MacOS 10.15及以上</span>
                    </div>
                    <div class="version-box"></div>
                    <div class="layer-1-3">
                      <a
                        href="https://download.haixingcloud.com/static/download/StarVictory.dmg"
                        class="ready-btn"
                        >MAC下载</a
                      >
                    </div>
                    <div class="version-update">
                      <div>版本&nbsp;{{ macNewVer.version_number || "" }}</div>
                      <div>
                        更新日期&nbsp;:&nbsp;&nbsp;{{
                          macNewVer.createdat | fmtDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- End single product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">安卓</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/images/xz/azsj.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span>适用于Android 8.0及以上</span>
                    </div>
                    <div class="version-box"></div>
                    <div class="layer-1-3">
                      <a
                        href="https://download.haixingcloud.com/static/download/haixingcloud-android-latest.apk"
                        class="ready-btn"
                        >安卓下载</a
                      >
                    </div>
                    <div class="version-update">
                      <div>
                        版本&nbsp;{{ androidNewVer.version_number || "" }}
                      </div>
                      <div>
                        更新日期&nbsp;:&nbsp;&nbsp;{{
                          androidNewVer.createdat | fmtDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- End ios product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">IOS</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/images/xz/ios.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span style="color: #12102f">适用于IOS 9.0及以上</span>
                    </div>
                    <div class="version-box"></div>
                    <div class="layer-1-3">
                      <a class="ready-btn">敬请期待</a>
                    </div>
                    <div class="version-update" style="color: #12102f">
                      <div>
                        版本&nbsp;{{ IOSVerNewVer.version_number || "" }}
                      </div>
                      <div>
                        更新日期&nbsp;:&nbsp;&nbsp;{{
                          IOSVerNewVer.createdat | fmtDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- Start single product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">安卓TV</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/images/xz/anzds.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span>适用于Android 8.0以上</span>
                    </div>
                    <div class="version-box"></div>
                    <div class="layer-1-3">
                      <a
                        href="https://download.haixingcloud.com/static/download/haixingcloud-android-tv-latest.apk"
                        class="ready-btn"
                        >安卓TV下载</a
                      >
                    </div>
                    <div class="version-update">
                      <div>
                        版本&nbsp;{{ androidTVNewVer.version_number || "" }}
                      </div>
                      <div>
                        更新日期&nbsp;:&nbsp;&nbsp;{{
                          androidTVNewVer.createdat | fmtDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- End single product -->
          </div>
        </div>
      </div>
    </div>
    <!-- End Product Area -->
    <!-- Start About Area -->
    <section class="m-About">
      <div class="page3" id="page3">
        <div class="page3_blur">
          <div class="log"></div>
        </div>
        <div
          class="page3_icon"
          style="
            left: 615px;
            top: 343px;
            display: block;
            z-index: 100;
            display: flex;
          "
          id="page3_icon"
        >
          <img draggable="false" src="../assets/images/hk/yb.png" />
          <img src="../assets/images/hk/sjx2.png" style="opacity: 0" />
          <img
            src="../assets/images/hk/hk.png"
            id="icon"
            style="margin-top: -5px; margin-left: 2px; display: block"
          />
          <img src="../assets/images/hk/sjx1.png" style="opacity: 0" />

          <img src="../assets/images/hk/zb.png" />
        </div>
      </div>
    </section>
    <!-- End About Area -->
    <!-- Start Product Area -->
    <!-- 全局qq和微信联系方式 index中有全局 -->
    <div class="hotline">
      <i class="fa fa-qq link"></i>
      <div class="qrcode-div">
        <img
          draggable="false"
          style="width: 100%; height: 100%"
          class="image"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/qqCode.png`"
        />
      </div>
    </div>
    <div class="hotline2">
      <i class="fa fa-wechat link-wechat"></i>
      <div class="qrcode-div2">
        <img
          draggable="false"
          class="image"
          style="width: 100%; height: 100%"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/Wechat2.jpg`"
        />
      </div>
    </div>
    <a class="phone_download" v-show="this.phone_download" :href="this.FG_link">
      <!-- <div class="pd_div"></div> -->
      <div class="pd_img">
        <img :src="this.FG_img" class="pd_img" />
      </div>
    </a>
  </main>
</template>
<script>
import { formatDate } from '@/common/utils.js'
export default {
  // 接收注入的数据
  inject: ['reload'],
  metaInfo: {
    title: '云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content: '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器,开启无比爽快的游戏体验'
      },
      {
        name: 'description',
        content: '海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      dialogVisible: false,
      timeer: '',
      dingshiqi: '',
      // 标识符
      flag: 0,
      one: '',
      open_id: '',
      access_token: '',
      token: '',
      isLoged: false,
      phone_download: false,

      pcVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      pc32Ver: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      macVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      androidVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      IOSVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      androidTVVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      FG_img: require('../assets/images/apple.png'),
      FG_link: '',
      win64or32: 64
    }
  },
  computed: {
    now () {
      return Date.now()
    },
    pcNewVer () {
      if (this.pcVer.newest_version !== undefined) {
        return (new Date(this.pcVer.new_version.createdat_str) > new Date(this.pcVer.newest_version.createdat_str)) ? this.pcVer.new_version : this.pcVer.newest_version
      }
      return this.pcVer.new_version
    },
    pc32NewVer () {
      if (this.pc32Ver.newest_version !== undefined) {
        return (new Date(this.pc32Ver.new_version.createdat_str) > new Date(this.pc32Ver.newest_version.createdat_str)) ? this.pc32Ver.new_version : this.pc32Ver.newest_version
      }
      return this.pc32Ver.new_version
    },
    macNewVer () {
      if (this.macVer.newest_version !== undefined) {
        return (new Date(this.macVer.new_version.createdat_str) > new Date(this.macVer.newest_version.createdat_str)) ? this.macVer.new_version : this.macVer.newest_version
      }
      return this.macVer.new_version
    },
    androidNewVer () {
      if (this.androidVer.newest_version !== undefined) {
        return (new Date(this.androidVer.new_version.createdat_str) > new Date(this.androidVer.newest_version.createdat_str)) ? this.androidVer.new_version : this.androidVer.newest_version
      }
      return this.androidVer.new_version
    },
    IOSVerNewVer () {
      if (this.IOSVer.newest_version !== undefined) {
        return (new Date(this.IOSVer.new_version.createdat_str) > new Date(this.IOSVer.newest_version.createdat_str)) ? this.IOSVer.new_version : this.IOSVer.newest_version
      }
      return this.IOSVer.new_version
    },
    androidTVNewVer () {
      if (this.androidTVVer.newest_version !== undefined) {
        return (new Date(this.androidTVVer.new_version.createdat_str) > new Date(this.androidTVVer.newest_version.createdat_str)) ? this.androidTVVer.new_version : this.androidTVVer.newest_version
      }
      return this.androidTVVer.new_version
    }
  },
  methods: {
    open () {
      this.$alert('<strong>打开App Store搜索"海星云"，下载海星云APP</strong>', '海星云提示您', {
        dangerouslyUseHTMLString: true
      })
    },
    detail () {
      this.$router.push('./Contact')
    },
    linkdenglu () {
      this.$emit('global:denglu')
    },
    showRouter () {
      // 调用reload方法，刷新整个页面
      this.reload()
    },
    getPcVer () {
      this.http.getLink(3).then(r => {
        this.pcVer = r.data.data
      })
    },
    get32PcVer () {
      this.http.getLink(5).then(r => {
        this.pc32Ver = r.data.data
      })
    },
    getMacVer () {
      this.http.getLink(2).then(r => {
        this.macVer = r.data.data
      })
    },
    getAndroidVer () {
      this.http.getLink(1).then(r => {
        this.androidVer = r.data.data
      })
    },
    getIOSVer () {
      this.http.getLink(6).then(r => {
        this.IOSVer = r.data.data
      })
    },
    getAndroidTVVer () {
      this.http.getLink(4).then(r => {
        this.androidTVVer = r.data.data
      })
    },
    _isMobile () {
      // const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (navigator.userAgent.match(/(pad|pod|iPhone|iPod|ios|iPad)/i)) {
        this.FG_img = require('../assets/images/apple.png')
        this.phone_download = true
        this.FG_link = 'https://testflight.apple.com/join/XnoiWO1x'
      } else if (navigator.userAgent.match(/(Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        this.FG_img = require('../assets/images/Android.png')
        this.phone_download = true
        this.FG_link = 'https://download.haixingcloud.com/static/download/haixingcloud-android-latest.apk'
      } else {
        this.phone_download = false
      }
      // return flag
    }
  },
  filters: {
    fmtDate: function (value) {
      if (!value) return
      return formatDate(new Date(value), 'yyyy年MM月dd日')
    }
  },
  created () {
    this.dialogVisible = true
    var url = window.location.href // 获取当前url
    var dz_url = url.split('#')[0] // 获取#/之前的字符串
    var cs = dz_url.split('?')[1] // 获取?之后的参数字符串
    if (cs) {
      var cs_arr = cs.split('&') || null // 参数字符串分割为数组
      var cs = {}
      for (var i = 0; i < cs_arr.length; i++) {
        // 遍历数组，拿到json对象
        cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
      }
      this.access_token = cs.access_token
      this.open_id = cs.open_id // 这样就拿到了参数中的数据
      this.token = cs.token

      window.location.replace(
        `${window.location.protocol}//${window.location.host}/#/Home?access_token=${this.access_token}&open_id=${this.open_id}&token=${this.token}`
      )
    }
  },
  mounted () {
    this._isMobile()
    if (this.$cookieStore.getCookie('user_sess')) {
      this.isLoged = true
    } else {
      this.isLoged = false
    }
    this.$nextTick(() => {
      let page3 = $('#page3')
      let page3_icon = $('#page3_icon')

      let width = page3.width()
      //   //获取div的初始位置，要注意的是需要转整型，因为获取到值带px
      //   var left = parseInt(aa.css("left"));
      //   var top = parseInt(aa.css("top"));
      page3.mousemove(function (e) {
        page3_icon
          .css('left', e.pageX + 'px')
          // .css('top', e.pageY - page3.offset().top-3800 + 'px')
          .css('top', e.clientY - page3.offset().top + 'px')
        $('.page3_blur').css('width', width - e.pageX + 'px')
      })
      var intro_carousel = $('.intro-carousel')
      intro_carousel.owlCarousel({
        loop: true,
        nav: true,
        autoplay: true,
        dots: false,
        navText: [
          "<i class='icon icon-chevron-left'></i>",
          "<i class='icon icon-chevron-right'></i>"
        ],
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      })
      var services_carousel = $('.services-carousel')
      services_carousel.owlCarousel({
        loop: true,
        nav: true,
        autoplay: true,
        dots: false,
        navText: [
          "<i class='icon icon-chevron-left'></i>",
          "<i class='icon icon-chevron-right'></i>"
        ],
        responsive: {
          0: {
            items: 1
          },
          700: {
            items: 3
          },
          1000: {
            items: 3
          }
        }
      })
    })

    this.getPcVer()
    this.get32PcVer()
    this.getMacVer()
    this.getAndroidVer()
    this.getAndroidTVVer()
    this.getIOSVer()

    var agent = navigator.userAgent.toLowerCase()
    if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
      this.win64or32 = 64
    } else {
      this.win64or32 = 32
    }
  }
}
</script>
<style lang="scss">
.phone_download {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 56px;
  width: 100%;
  z-index: 100;
  display: block;

  background-color: rgba(0, 0, 0, 0.31);
  border-radius: 5px;
  font-family: sans-serif;
  text-align: center;
  line-height: 1;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  // max-width: 50%;
  // max-height: 50%;
  padding: 20px 40px;
}
.pd_img {
  width: 100px;
  height: 27.2px;
  margin: -8px auto 0;
  position: relative;
  display: block;
}
.pd_img img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 425px) {
  .el-kuang {
    .el-dialog {
      width: 80% !important;
    }
  }
}
@media screen and (min-width: 425px) and (max-width: 750px) {
  .el-kuang {
    .el-dialog__body {
      width: 100% !important;
    }
  }
}
@media screen and (min-width: 1500px) {
  .el-kuang {
    .el-dialog {
      width: 30% !important;
    }
  }
}
.el-dialog {
  transition-duration: 0.6s;
}
.el-kuang {
  // background-attachment: fixed;
  // overflow: hidden;
  .el-dialog__header {
    padding: 0 !important;
    .el-dialog__headerbtn {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #ccc;
      display: flex;
      align-items: center;
      justify-content: center;
      right: -15px;
      top: -15px;
      .el-dialog__close {
        color: #000;
        font-size: 20px;
      }
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .layer_h2 {
    font-size: 48px;
    line-height: 80px;
  }
  @media screen and(max-width: 749px) {
    .layer_h2 {
      font-size: 25px;
      line-height: 40px;
      margin: 0 !important;
    }
    .layer-1-3 {
      // display: none;
    }
    .laryer_hidden {
      display: block !important;
      margin: 20px auto 40px !important;
    }
    .laryer_hidden p {
      font-size: 14px !important;
    }
  }
  @media screen and(min-width: 750px) and(max-width: 999px) {
    .layer_h2 {
      font-size: 36px !important;
      line-height: 42px !important;
    }
  }
  @media screen and(min-width: 990px) and(max-width: 1200px) {
    .layer_h2 {
      font-size: 50px !important;
      line-height: 55px !important;
    }
  }
}
</style>
<style scoped>
.version-update {
  margin-top: 10px;
  font-size: 12px;
  color: #e3e3e8;
  opacity: 0.8;
}
@media screen and (min-width: 770px) and (max-width: 990px) {
  .lunbotu {
    background: rgba(18, 16, 47, 0.96) none repeat scroll 0 0;
    padding-top: 180px;
  }
}
@media screen and (max-width: 765px) {
  .lunbotu {
    background: rgba(18, 16, 47, 0.96) none repeat scroll 0 0;
    padding-top: 66px;
  }
}
@media screen and (min-width: 1200px) {
  .lunbotu {
    background: rgba(18, 16, 47, 0.96) none repeat scroll 0 0;
    padding-top: 114px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue